jQuery( $ => {
	const $body = $( 'body' );

	// Checks if we're seeing a subscription product.
	const subscriptionIntervals = $( '.variations select.woo-variation-raw-select' );
	if ( subscriptionIntervals ) {
		displaySubscriptionPercentage( subscriptionIntervals );
	}

	/**
	 * Trigger accordion.
	 */
	$( '.product-block-content > h2' ).on( 'click keydown', function( e ) {
		if ( e.type === 'click' || e.key === 'Enter' || e.key === ' ' ) {
			e.preventDefault();
			const $parentEl = $( this ).closest( '.product-block' );
			toggleProductBlock( $parentEl );
		}
	} );

	/**
	 * Make changes to the page whenever a change in the variations occurs.
	 * Show variation selection along with the label.
	 * Show the variations price instead of the price range.
	 *
	 */
	$body.on( 'change', '.variations select', function() {
		setTimeout( setVariationPricing, 200 );
	} ).trigger( 'change' );

	/**
	 * Toggles a product blocks accordion.
	 *
	 * @param {Object}  blockEl   the outer block element.
	 * @param {boolean} forceOpen wether it should be forced to open.
	 */
	function toggleProductBlock( blockEl, forceOpen = false ) {
		const trigger = blockEl.find( 'h2' );
		const content = blockEl.find( '.product-block-inner-content' );

		if ( forceOpen ) {
			blockEl.removeClass( 'accordion-hidden' );
			trigger.attr( 'aria-expanded', 'true' );
			content.attr( 'aria-hidden', 'false' );
			return;
		}
		// Toggle class for the block which sets visibility.
		blockEl.toggleClass( 'accordion-hidden' );
		// Aria for the h2 trigger element.
		trigger.attr( 'aria-expanded', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );
		// Aria for the hidden content.
		content.attr( 'aria-hidden', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );
	}

	// Save the original product price html so it can be reset.
	const originalPrice = $( '.summary-inner-wrapper > .price' ).html();

	/**
	 * Changes the price displayed to that of the chosen variation.
	 */
	function setVariationPricing() {
		const variationId = $( 'input[name="variation_id"]' ).val();
		let $priceEl = $( '.summary-inner-wrapper > .price' );

		if ( ! $priceEl.length ) {
			$priceEl = $( '.qala-quickview-product-container__right .price' );
		}

		// No variation selected means we want to reset the product price html and bail.
		if ( undefined === variationId || 0 === parseInt( variationId ) || '' === variationId ) {
			$priceEl.html( originalPrice );
			return;
		}

		// Get the variation price and overwrite the range pricing html.
		const variationPrice = $( '.woocommerce-variation-price .price' ).html();
		$priceEl.html( variationPrice );

		// Checks if we're seeing a subscription product.
		if ( subscriptionIntervals ) {
			displaySubscriptionPercentage( subscriptionIntervals );
		}
	}

	/**
	 * Toggles visibility on percentage discount label for the options that have it.
	 *
	 */
	function displaySubscriptionPercentage() {
		const selectedInterval = subscriptionIntervals.find( ':selected' ).val();

		$( '.subscription-product-content--sale-label' ).each( function() {
			const labelInterval = $( this ).attr( 'data-sub_interval' );
			$( this ).removeClass( 'active' );
			if ( selectedInterval === labelInterval ) {
				$( this ).addClass( 'active' );
			}
		} );
	}
} );
